<!--
  用例：
  imgUrl: 图片url，
  @change：图片改变的回调，返回file对象
  fixed: 是否固定宽高
  fixedWidth: 截图区域固定的宽
  fixedHeight: 截图区域固定的高
  width: 容器宽度
  height: 容器高度
  <img-cropper v-model="imgUrl" @change="imgChange"></img-cropper>
-->

<template>
  <div class="img-cropper">
    <label class="btn btn-default" :for="id">
      <i class="el-icon-upload m-r-5"></i>
      <span>{{ $t('img_cropper.upload_img') }}</span>
    </label>
    <input
      :id="id"
      ref="file"
      type="file"
      class="btn btn-default btn-sm"
      style="position:absolute; clip:rect(0 0 0 0);"
      accept="image/png, image/jpeg, image/gif, image/jpg"
      @change="uploadImg($event, 1)"
    />
    <br />
    <div v-if="img" class="cut m-t-10" :style="computeSize">
      <vue-cropper
        ref="cropper"
        :img="img"
        :auto-crop-width="fixedWidth"
        :auto-crop-height="fixedHeight"
        :fixed="fixed"
        :fixed-number="fixedNumber"
        :full="true"
        :auto-crop="true"
        :enlarge="5"
        @real-time="realTime"
      ></vue-cropper>
    </div>
    <div v-if="isUpload" class="test-button">
      <button type="button" class="btn btn-default btn-sm" @click="refreshCrop">{{ $t('img_cropper.reset') }}</button>
      <button type="button" class="btn btn-default btn-sm" @click="changeScale(1)">{{ $t('img_cropper.amplification') }}</button>
      <button type="button" class="btn btn-default btn-sm" @click="changeScale(-1)">{{ $t('img_cropper.narrow') }}</button>
      <button type="button" class="btn btn-default btn-sm" @click="rotateLeft">
        <img src="/images/groups/rotate-on-left.svg" alt="" width="20" />
      </button>
      <button type="button" class="btn btn-default btn-sm" @click="rotateRight">
        <img src="/images/groups/rotate-on-right.svg" alt="" width="20" />
      </button>
    </div>
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
export default {
  components: {
    VueCropper
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'uploads'
    },
    fixed: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 250
    },
    height: {
      type: Number,
      default: 250
    },
    fixedWidth: {
      type: Number,
      default: 130
    },
    fixedNumber: {
      type: Array,
      default: () => {
        return [1, 1]
      }
    },
    fixedHeight: {
      type: Number,
      default: 130
    }
  },
  data() {
    return {
      img: '',
      isUpload: false,
      imgName: ''
    }
  },
  computed: {
    computeSize() {
      return `width:${this.fixedWidth > this.width ? this.fixedWidth : this.width}px;height:${
        this.fixedHeight > this.height ? this.fixedHeight : this.height
      }px;`
    }
  },
  watch: {
    value(val) {
      this.img = val
    }
  },
  destroyed() {
    this.isUpload = false
  },
  methods: {
    refreshCrop() {
      // refresh
      this.$refs.cropper.refresh()
    },
    clearCrop() {
      // clear
      this.$refs.file.value = ''
      this.isUpload = false
      this.img = ''
      let refCropper = this.$refs.cropper
      if (refCropper) {
        this.$refs.cropper.clearCrop()
        this.$refs.cropper.stopCrop()
      }
    },
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },

    // 实时预览函数
    realTime() {
      this.$refs.cropper.getCropBlob(data => {
        // do something
        let file = new window.File([data], this.imgName, { type: data.type })
        this.$emit('change', file)
      })
    },

    //上传图片
    uploadImg(e) {
      var file = e.target.files[0]
      this.imgName = file.name
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        return false
      }
      var reader = new FileReader()
      reader.onload = e => {
        let data
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        this.img = data
      }
      this.isUpload = true
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file)
    }
  }
}
</script>

<style lang="scss" scoped>
.cut {
  display: inline-block;
  vertical-align: bottom;
}

.c-item {
  max-width: 800px;
  margin: 10px auto;
  margin-top: 20px;
}

.content {
  margin: auto;
  max-width: 1200px;
  margin-bottom: 100px;
}

.test-button {
  height: 250px;
  width: 100px;
  margin-left: 10px;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
}

.test-button .schema-primary-btn:hover {
  color: #fff;
}

.des {
  line-height: 30px;
}

code.language-html {
  padding: 10px 20px;
  margin: 10px 0px;
  display: block;
  background-color: #333;
  color: #fff;
  overflow-x: auto;
  font-family: Consolas, Monaco, Droid, Sans, Mono, Source, Code, Pro, Menlo, Lucida, Sans, Type, Writer, Ubuntu, Mono;
  border-radius: 5px;
  white-space: pre;
}

.show-info {
  margin-bottom: 50px;
}

.show-info h2 {
  line-height: 50px;
}

.model {
  position: fixed;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
}

.model-show {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}

.model img {
  display: block;
  margin: auto;
  max-width: 80%;
  user-select: none;
  background-position: 0px 0px, 10px 10px;
  background-size: 20px 20px;
  background-image: linear-gradient(45deg, #eee 25%, transparent 25%, transparent 75%, #eee 75%, #eee 100%),
    linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
}

.c-item {
  display: block;
  user-select: none;
}

@keyframes slide {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.clear-float {
  clear: both;
  padding-bottom: 12px;
  margin: 24px 0px;
  border-bottom: 1px solid #d1d5df;
}
</style>
